import React from 'react';
import { styleDefinitions as styles } from '../../theme/styles';
import { Search } from 'lucide-react';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  resultCount?: number;
}

export const SearchBar: React.FC<SearchBarProps> = ({ value, onChange, resultCount }) => {
  return (
    <div style={styles.components.searchBar.container}>
      <div style={styles.components.searchBar.icon}>
        <Search size={20} />
      </div>
      <input
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        style={{
          ...styles.components.searchBar.input,
          ...(value && styles.components.searchBar.inputActive)
        }}
        placeholder="Search by name, description, tags..."
        onFocus={(e) => {
          Object.assign(e.target.style, styles.components.searchBar.inputFocus);
        }}
        onBlur={(e) => {
          if (!value) {
            Object.assign(e.target.style, styles.components.searchBar.input);
          }
        }}
      />
      {value && (
        <div style={styles.components.searchBar.results}>
          <span style={styles.components.searchBar.resultsText}>
            {resultCount} {resultCount === 1 ? 'result' : 'results'}
          </span>
          <button
            onClick={() => onChange('')}
            style={styles.components.searchBar.clearButton}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}
            aria-label="Clear search"
          >
            ×
          </button>
        </div>
      )}
    </div>
  );
};